module.exports = __webpack_public_path__ + "img/icon-error.e43df5ac.svg";